import MessageContainer from "./MessageContainer";
import MessageFooter from "./MessageFooter";

export default function TextMessage({ message }) {
  const { content, direction, status, createdAt } = message;
  const isOutbound = direction === "OUTBOUND";

  return (
    <MessageContainer isOutbound={isOutbound}>
      <div className="break-words whitespace-pre-wrap text-[15px]">
        {content.text}
      </div>
      <MessageFooter status={status} timestamp={createdAt} isOutbound={isOutbound} />
    </MessageContainer>
  );
}
